import { Link } from "react-router-dom";
import { Show, UserButton } from "@clerk/react";
import { Droplets, LayoutDashboard } from "lucide-react";

export const Header = () => (
  <header className="sticky top-0 z-40 border-b border-white/5 bg-[#0B1017]/70 backdrop-blur-xl">
    <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6">
      <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5">
        <span className="grid h-9 w-9 place-items-center rounded-xl bg-[#00F0FF] text-[#090E17]">
          <Droplets size={20} strokeWidth={2.5} />
        </span>
        <span className="font-display text-lg font-bold tracking-tight">
          Recenzii <span className="text-[#00F0FF]">Spălătorie</span>
        </span>
      </Link>
      <div className="flex items-center gap-3">
        <Link
          to="/admin"
          data-testid="nav-manager-btn"
          className="flex items-center gap-2 rounded-full border border-white/10 px-4 py-2 text-sm font-medium text-slate-300 transition-colors hover:border-[#00F0FF]/60 hover:text-white"
        >
          <LayoutDashboard size={16} />
          <span className="hidden sm:inline">Panou Manager</span>
        </Link>
        <Show when="signed-in">
          <div data-testid="nav-user-button"><UserButton /></div>
        </Show>
      </div>
    </div>
  </header>
);
